











































































import Vue from 'vue'
import { Prop } from 'vue-property-decorator'
import { Component } from '@niknevis/vue-modules'
import Modal from '@/modules/common/dialog/components/shared/Modal.vue'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import BaseInput from '@/modules/shared/components/shared/kit/BaseInput.vue'
import BaseSelect from '@/modules/shared/components/shared/kit/BaseSelect.vue'
import { ProfitType } from '@/modules/profit/models/profit-resource.model'
import { ProfitRequest } from '@/modules/profit/models/profit-request.model'
import CurrencyInput from '@/modules/shared/components/shared/form/CurrencyInput.vue'
import { BaseRequestLoadingHandler } from '@/modules/shared/interfaces/base-request-loading-handler.interface'


@Component({
  components: { CurrencyInput, BaseInput, Modal, BaseButton, BaseSelect }
})
export default class ProfitChangeDialog extends Vue {
  @Prop({ default: null }) useCase!: BaseRequestLoadingHandler
  @Prop() id!: number[] | number

  private dialogModel: boolean = false
  private profit: ProfitRequest = {
    amount: 0,
    type: ProfitType.INCREASE,
    description: ''
  }
  private typeOptions = [{ label: 'افزایشی', value: ProfitType.INCREASE }, {
    label: 'کاهشی',
    value: ProfitType.DECREASE
  }]


  onSubmit(evt) {
    if (this.useCase !== null)
      this.useCase.execute(this.id, this.profit).then(() => {
        if (this.useCase.isSuccess) this.onSuccess()
      })
    else this.dialogModel = false
  }

  onOpen() {
    this.dialogModel = true
    this.clearProfit()
  }

  onSuccess() {
    this.dialogModel = false
    this.clearProfit()
  }

  clearProfit() {
    this.profit = {
      amount: 0,
      type: ProfitType.INCREASE,
      description: ''
    }
  }
}
